import { Outlet, createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ChildRouteContext } from "@/root";

import { chartTypes } from "@/modules/chart/shared/constants";

export const Route = createFileRoute("/admin/_panel/_chart/chart/$type")({
  component: RouteComponent,
  parseParams: (params) => ({
    type: z.enum(chartTypes).parse(params.type),
  }),
  beforeLoad: () =>
    ({
      crumb: [],
    }) satisfies ChildRouteContext,
  stringifyParams: ({ type }) => ({ type: `${type}` }),
});

function RouteComponent() {
  return <Outlet />;
}
